import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_TOGGLE_MENU} from "../../constants";

export function MenuHeader({children}) {
  const dispatch = useDispatch();
  const isActive = useSelector(state => state.common.menu);

  const toggle = () => {
    dispatch({type: UPDATE_TOGGLE_MENU, menu: !isActive});
  };

  return <header className={"header" + (isActive ? " header--nav" : "")}>
    <button className={"hamburger" + (isActive ? " hamburger--active" : "")} onClick={toggle}>
      Меню
      <span className="hamburger__inner"></span>
      <span className="hamburger__inner"></span>
      <span className="hamburger__inner"></span>
    </button>
    {children}
  </header>;
}
